import { LoadingDirectiveModule } from '@shared/loading-directive/loading-directive.module';
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {Login2Component} from '@app/components/login/login-2.component';

import {StatusComponent} from './components/_common/status/status.component';
import {AuthGuardService as AuthGuard} from './services/auth/auth-guard.service';

import {ImagePickerComponent} from '@app/components/_common/medias/image-picker/image-picker.component';
import {GenericListResolver} from '@app/components/lists/generic-reference-list/generic-list-resolver';
import {CommunitiesResolver} from '@app/components/projects/communities/communities.resolver';
import {AuthResolver} from '@store/auth.resolver';
import {ProfileComponent} from '@app/components/_common/profile/profile.component';

const routes: Routes = [

  // -------------------------------------------------------------------------------------------------------------------------//
  //
  // Login
  //
  // {path: 'log-in', loadChildren: () => import('./components/login/login-2.module').then((m) => m.Login2Module)},
  // {path: 'auth', loadChildren: () => import('./components/login/login-2.module').then((m) => m.Login2Module)},

  {
    path: 'log-in',
    component: Login2Component,
    resolve: {data: AuthResolver},
  },
  {
    path: 'log-in/:token',
    component: Login2Component,
    resolve: {data: AuthResolver},
  },
  {
    path: 'auth/login',
    component: Login2Component,
    resolve: {data: AuthResolver},
  },
  {
    path: 'profile',
    component: ProfileComponent,
    resolve: {data: AuthResolver},
  },
  //
  // Login for annotators via secretKey
  {
    path: 'auth/annotation/:secretKey',
    component: Login2Component,
    resolve: {data: AuthResolver},
  },
  //
  // Login with token :
  {
    path: 'auth/login/:token',
    component: Login2Component,
    resolve: {data: AuthResolver},
  },

  // ------------------------------------------------------------------------------------------------------------------------------------
  // Listes de références...
  //
  {
    path: 'storeTree',
    loadComponent: () => import('./4dm1n/store-tree/store-tree.component').then((mod) => mod.StoreTreeComponent),
    canActivate: [AuthGuard],
  },
  //
  //
  //

  // ------------------------------------------------------------------------------------------------------------------------------------
  // Listes de références...
  //
  {
    path: 'surveys',
    loadComponent: () => import('./components/lists/surveys/surveys-list-reference.component').then((mod) => mod.SurveysListReferenceComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'referenceList/:listType',
    loadComponent: () => import('./components/lists/generic-reference-list/generic-reference-list.component').then((mod) => mod.GenericReferenceListComponent),
    resolve: {data: GenericListResolver},
    canActivate: [AuthGuard],
  },
  //
  // ------------------------------------------------------------------------------------------------------------------------------------

  //
  // Détail d'une communauté
  {
    path: 'community/:comId',
    loadComponent: () => import('./components/projects/communities/communities.component').then((mod) => mod.CommunitiesComponent),
    resolve: {data: CommunitiesResolver},
    canActivate: [AuthGuard],
  },
  //
  //

  //
  {path: 'status', component: StatusComponent, canActivate: [AuthGuard]},
  {path: 'mediasGallery', component: ImagePickerComponent, canActivate: [AuthGuard]},

  //
  // Results (Dashboard)
  // eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ2ZXJzaW9uIjoxLCJpZCI6MjMwMDAxLCJvcmdhbml6YXRpb25JZCI6NDczLCJ1c2VyQWNjZXNzIjp7IkdPRF9NT0RFIjpmYWxzZX0sImlhdCI6MTcyMjI3Mjc5NywiZXhwIjoxNzMzMDcyNzk3fQ.FsGzQSm_6k6Es0rd0mfMHrWRxGOj_O1hLDl1Xvgo28k
  {
    path: 'results/survey',
    loadChildren: () => import('./components/projects/surveys/results/results.module').then((m) => m.ResultsModule),
    resolve: {data: AuthResolver},
    canActivate: [AuthGuard],
  },

  // http://localhost:4200/public/results/dashboard/eb692b66-f1c2-401b-aff9-7ade27f6143b
  {
    path: 'public/results',
    loadChildren: () => import('./components/projects/surveys/results/results.module').then((m) => m.ResultsModule),
  },

  // {
  //   path: 'results/dashboard/:dashboardId',
  //   loadChildren: () =>
  //     import('./components/projects/surveys/results/results.module').then((m) => m.ResultsModule),
  //   canActivate: [AuthGuard],
  // },

  // http://localhost:4200/results/public/dashboard/eb692b66-f1c2-401b-aff9-7ade27f6143b
  // {
  //   path: 'results/public/dashboard/:dashboardId',
  //   loadChildren: () =>
  //     import('./components/projects/surveys/results/results.module').then((m) => m.ResultsModule),
  // },

  //
  // Autres routes !
  //
  {
    path: 'results/recruitment/:pubUuid',
    loadChildren: () => import('./components/publications/publications-dashboard-recruitment/publications-dashboard-recruitment.module').then((m) => m.PublicationsDashboardRecruitmentModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'results/recruitment/:pubUuid/:stage',
    loadChildren: () => import('./components/publications/publications-dashboard-recruitment/publications-dashboard-recruitment.module').then((m) => m.PublicationsDashboardRecruitmentModule),
    canActivate: [AuthGuard],
  },

  //
  // Annotations
  // { path: 'annotation/:surveyId', component: AnnotationComponent },
  {
    path: 'annotation/:surveyId',
    loadChildren: () => import('./components/projects/surveys/annotation/annotation.module').then((m) => m.AnnotationModule),
    canActivate: [AuthGuard],
  },

  //
  // Builder
  //
  {
    path: 'survey/builder',
    loadChildren: () => import('./components/projects/surveys/builder/builder.module').then((m) => m.BuilderModule),
    canActivate: [AuthGuard],
  },

  //
  // 4dm1n
  // { path: '4dm1n/surveysList', component: AnnotationComponent },
  {
    path: '4dm1n',
    loadChildren: () => import('./4dm1n/Adm1n.module').then((m) => m.Adm1nModule),
    canActivate: [AuthGuard],
  },
  {
    path: '4dm1n/tokenLogin/:token',
    loadChildren: () => import('./4dm1n/Adm1n.module').then((m) => m.Adm1nModule),
  },
  {
    path: '4dm1n/workersDashboard',
    loadComponent: () => import('../app/4dm1n/works-dashboard/works-dashboard.component').then((mod) => mod.WorksDashboardComponent),
    canActivate: [AuthGuard],
  },

  //
  // Projects / ExtProfils
  // ? Pouruqoi le lazyLoad ne marche pas ?
  {
    path: 'projects/extprofils',
    // component: ExtProfilsComponent,
    // loadChildren: () =>
    //   import('./components/projects/ext-profils/ext-profils.module').then(
    //     (m) => m.ExtProfilsModule,
    //   ),
    loadChildren: () => import('./components/projects/ext-profils/ext-profils.module').then((m) => m.ExtProfilsModule),
    canActivate: [AuthGuard],
  },

  //
  // Publication
  {
    path: 'publications/dashboardV2/display/:uuid',
    loadComponent: () => import('./components/publications/publication-dashboard-v2/publication-dashboard-v2.component').then((mod) => mod.PublicationDashboardV2Component),
    canActivate: [AuthGuard],
  },
  {
    path: 'publications',
    loadChildren: () => import('./components/publications/publications.module').then((m) => m.PublicationsModule),
    canActivate: [AuthGuard],
  },

  //
  // transcribe
  {
    path: 'transcribe',
    loadChildren: () => import('./components/transcribe/transcribe.module').then((mod) => mod.TranscribeModule),
    canActivate: [AuthGuard],
  },

  //
  // GPT-5 Survey Analysis
  {
    path: 'surveys/gpt-analysis',
    loadComponent: () => import('./components/projects/surveys/survey-gpt-analysis-page/survey-gpt-analysis-page.component').then((mod) => mod.SurveyGptAnalysisPageComponent),
    canActivate: [AuthGuard],
  },

  //
  // internal
  {
    path: 'internal',
    loadChildren: () => import('./components/_internal/internal.module').then((mod) => mod.InternalModule),
    canActivate: [AuthGuard],
  },



  //
  // Emails
  {
    path: 'email',
    loadChildren: () => import('./components/projects/eMailCampaigns/e-mail-campaigns.module').then((m) => m.EMailCampaignsModule),
    canActivate: [AuthGuard],
  },

  // {path: '', component: LandingComponent, canActivate: [AuthGuard]},
  {
    path: '',
    loadChildren: () => import('./components/landing/landing.module').then((m) => m.LandingModule),
    canActivate: [AuthGuard],
  },

  {path: '**', redirectTo: '/'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing: false})],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
